import { useRef } from 'react';

// What a drag step rewrites on a task (useBoardDrag): nothing else changes.
const MOVE_KEYS = new Set(['groupId', 'position']);

function sameButMoved(a, b) {
  if (a === b) return true;
  if (!a || !b || a.id !== b.id) return false;
  const keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) return false;
  return keys.every((k) => MOVE_KEYS.has(k) || a[k] === b[k]);
}

/**
 * The board's tasks, but the SAME array while only their list or position
 * changed (owner, 13.10.2026: dragging lagged on 80+ task boards). The filter
 * bar counts overdue / priority / labels — none of which a move changes — and
 * measures its chips in a layout effect on every render, which forced a full
 * layout of the board on each drag step. With this it re-renders only when a
 * task really changed.
 */
export default function useMoveStableTasks(tasks) {
  const ref = useRef(tasks);
  const prev = ref.current;
  const list = tasks || [];
  // By id, not index: a move also reorders the array (useBoardDrag rebuilds it list by list).
  let same = prev === tasks;
  if (!same && prev && prev.length === list.length) {
    const byId = new Map(prev.map((t) => [t?.id, t]));
    same = list.every((t) => sameButMoved(byId.get(t?.id), t));
  }
  if (!same) ref.current = tasks;
  return ref.current;
}
